import { isNil } from 'lodash-es';
import { fastDom } from '../dom';
export function createHierarchicalListInspector({ rootContainerSelector, containerSelector, itemSelector, handleSelector, }) {
    return new HierarchicalListInspector(rootContainerSelector, containerSelector, itemSelector, handleSelector);
}
export function createFlatListInspector({ rootContainerSelector, itemSelector, handleSelector, }) {
    return new FlatListInspector(rootContainerSelector, itemSelector, handleSelector);
}
class BaseInspector {
    static createDataSelector(key, value) {
        return isNil(value) ? `[data-${key}]` : `[data-${key}="${value}"]`;
    }
    constructor(rootContainerSelector, itemSelector, handleSelector) {
        this.rootContainerSelector = rootContainerSelector;
        this.itemSelector = itemSelector;
        this.handleSelector = handleSelector;
    }
    getRootContainer() {
        return document.querySelector(this.rootContainerSelector);
    }
    getClosestContainer(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _container) {
        return this.getRootContainer();
    }
    getClosestElement(item) {
        var _a;
        if (isNil(item)) {
            throw new Error('item is undefined');
        }
        else if (item instanceof HTMLElement) {
            return ((_a = item.closest(this.itemSelector)) !== null && _a !== void 0 ? _a : undefined);
        }
        else {
            throw new Error('item is not an HTMLElement');
        }
    }
    getParentContainer(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _) {
        return this.getRootContainer();
    }
    getRearrangingHandles(root) {
        if (!isNil(this.handleSelector) && root instanceof HTMLElement) {
            return [
                ...root.querySelectorAll(this.handleSelector),
            ];
        }
        else {
            return this.getChildElements(this.getRootContainer());
        }
    }
    getChildElements(container) {
        if (container instanceof HTMLElement) {
            return [
                ...container.querySelectorAll(this.itemSelector),
            ];
        }
        else {
            throw new Error('container is not an HTMLElement');
        }
    }
    getFirstChildElement(container) {
        if (container instanceof HTMLElement) {
            return container.querySelector(this.itemSelector);
        }
        else {
            throw new Error('container is not an HTMLElement');
        }
    }
    async getBoundingRect(element) {
        if (element instanceof HTMLElement) {
            return fastDom.measure(() => element.getBoundingClientRect());
        }
        else {
            throw new Error('element is not an HTMLElement');
        }
    }
    findElementByData(key, value) {
        const selector = HierarchicalListInspector.createDataSelector(key, value);
        const insertionPoint = this.getRootContainer().querySelector(selector);
        if (!isNil(insertionPoint)) {
            return insertionPoint;
        }
        else {
            return undefined;
        }
    }
    findAllElementsByData(key, value) {
        const selector = HierarchicalListInspector.createDataSelector(key, value);
        const insertionPoints = this.getRootContainer().querySelectorAll(selector);
        return [...insertionPoints];
    }
    isDescendant(child, parent) {
        if (child === parent) {
            return true;
        }
        if (isNil(child.parentElement)) {
            return false;
        }
        return this.isDescendant(child.parentElement, parent);
    }
    getWindow() {
        return window;
    }
}
class FlatListInspector extends BaseInspector {
    constructor(rootContainerSelector, itemSelector, handleSelector) {
        super(rootContainerSelector, itemSelector, handleSelector);
    }
    getClosestContainer(container) {
        if (container instanceof HTMLElement) {
            return container.closest(this.itemSelector);
        }
        else {
            throw new Error('container is not an HTMLElement');
        }
    }
}
class HierarchicalListInspector extends BaseInspector {
    constructor(rootContainerSelector, containerSelector, itemSelector, handleSelector) {
        super(rootContainerSelector, itemSelector, handleSelector);
        this.containerSelector = containerSelector;
    }
    getClosestContainer(container) {
        if (container instanceof HTMLElement) {
            return container.closest(this.containerSelector);
        }
        else {
            throw new Error('container is not an HTMLElement');
        }
    }
    getParentContainer(container) {
        var _a;
        if (container instanceof HTMLElement) {
            return (_a = container.parentElement) === null || _a === void 0 ? void 0 : _a.closest(this.containerSelector);
        }
        else {
            throw new Error('container is not an HTMLElement');
        }
    }
}
